/** A constant in the old code. */
export const BLOCK_SIZE = 10;

export const getDivisionsPerBlock = (milesPerDivision: number) => BLOCK_SIZE / milesPerDivision;
